import { Injectable, EventEmitter } from '@angular/core';
import { DynamicComponentService } from "../dynamic.service";
import { AlertDialogComponent } from "../dialog/alert.component";
import { ConfirmDialogComponent } from "../dialog/confirm.component";
import { PromptDialogComponent } from "../dialog/prompt.component";

/**
 * Сервис для вывода 3-х видов диалоговых окон. alert, confirm, prompt
 */
@Injectable()
export class DialogService {

    constructor( private _dynComponent:DynamicComponentService) { }
    /**
     * Важное сообщение.
     * @param message Текст сообщения
     */
    alert(message="Сообщение"){
        let instance = this._dynComponent.attach(AlertDialogComponent);
        instance.message = message;
    }
    /**
     * 
     * @param message Текст сообщения
     * @param onOk Функция выполняющаяся после нажатия ОК(true) или Отмена(false)
     */
    confirm(message="Подтвердите",  onOk:(value:boolean)=>void){
        let instance = this._dynComponent.attach(ConfirmDialogComponent);
        instance.message = message;
        instance.onOkEmitter.subscribe((value)=>{
            onOk(value);
        });
    }
    /**
     * Диалоговое окно с полем ввода.
     * @param message Текст сообщения
     * @param value Значение поля ввода по умолчанию.
     * @param onOk Функция выполняется после нажатия ОК. Должна вернуть true для закрытия окна
     */
    prompt(message="Введите значение", value:string, onOk:(value:string)=>boolean){
        let instance = this._dynComponent.attach(PromptDialogComponent);
        instance.message = message;
        instance.input = value;
        instance.onOkEmitter.subscribe((value)=>{
            if(onOk(value)){
                instance.close();
            }
        });
    }
}